import {
  CHAT_SEND_REFUSED_BUSY_DETAIL,
  CHAT_SEND_REFUSED_BUSY_TITLE,
  ChatSendRefusedBusyError,
} from "../chat-send-refusal";
import { ChatErrorDisclosure, getChatErrorDetail } from "./chat-error-disclosure";
import { ChatMessage, ChatMessageContent } from "./chat-message";

export interface ErrorChatSessionMessageProps {
  error: Error;
}

export const ErrorChatSessionMessage = ({ error }: ErrorChatSessionMessageProps) => {
  // A concurrent-send refusal gets its own headline — nothing went wrong with the response Alby was
  // generating. It keeps the error styling because the outcome for this broker is still "your message
  // did not go". Every other error keeps the generation-error copy and the parsed server detail.
  const disclosure =
    error instanceof ChatSendRefusedBusyError
      ? { title: CHAT_SEND_REFUSED_BUSY_TITLE, detail: CHAT_SEND_REFUSED_BUSY_DETAIL }
      : { detail: getChatErrorDetail(error) };

  return (
    <ChatMessage>
      <ChatMessageContent>
        <ChatErrorDisclosure {...disclosure} />
      </ChatMessageContent>
    </ChatMessage>
  );
};
